<template>
    <a-modal v-bind:open="computedShowModal"
        width="600px"
        :closable="true"
        :footer="null"
        :mask-closable="false"
        :mask-style="{backdropFilter: 'blur(2px)'}"
        :keyboard="false"
        title="계정 정보 수정"
        :centered="true"
        @cancel="uiHandler.closeModal"
    >
        <div class="modal-content-body">
            <a-form
                ref="formRef"
                :model="formState"
                :rules="rules"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                label-align="left"
                style="display: flex; flex-direction: column; gap: 8px;"
            >
                <a-form-item :colon="false" ref="deptName" name="deptName">
                    <template #label>
                        <form-label
                            label-title="부서명"
                            :is-required="false"
                        />
                    </template>
                    <a-col >
                        <a-input v-model:value="formState.deptName"
                            placeholder="부서명을 입력해주세요"
                        />
                    </a-col>
                </a-form-item>
                <a-form-item :colon="false" ref="duty" name="duty">
                    <template #label>
                        <form-label
                            label-title="직급"
                            :is-required="false"
                        />
                    </template>
                    <a-col >
                        <a-input v-model:value="formState.duty"
                            placeholder="직급을 입력해주세요"
                        />
                    </a-col>
                </a-form-item>
                <a-form-item :colon="false" ref="name" name="name">
                    <template #label>
                        <form-label
                            label-title="이름"
                            :is-required="true"
                        />
                    </template>
                    <a-col >
                        <a-input v-model:value="formState.name"
                            placeholder="직원 이름을 입력해주세요"
                        />
                    </a-col>
                </a-form-item>
                <a-form-item :colon="false" ref="username" name="username">
                    <template #label>
                        <form-label
                            label-title="아이디"
                            :is-required="false"
                        />
                    </template>
                    <a-col class="btn-right">
                        <a-input v-model:value="formState.username"
                            disabled
                        />
                    </a-col>
                </a-form-item>
                <a-form-item :colon="false" :maxlength="16">
                    <template #label>
                        <form-label
                            label-title="비밀번호"
                            :is-required="false"
                        />
                    </template>
                    <a-col >
                        <a-button
                            class="black"
                            @click="uiHandler.resetPassword"
                        >
                            비밀번호 초기화
                        </a-button>
                    </a-col>
                </a-form-item>
                <a-form-item :colon="false" ref="mobile" name="mobile">
                    <template #label>
                        <form-label
                            label-title="휴대폰 번호"
                            :is-required="true"
                        />
                    </template>
                    <a-col >
                        <a-input v-model:value="formState.mobile"
                            :maxlength="13"
                            placeholder="휴대폰 번호를 입력해주세요"
                        />
                    </a-col>
                </a-form-item>
            </a-form>
        </div>
        <div class="create-acc-modal-footer">
        <a-button
            @click="uiHandler.closeModal"
        >
            취소
        </a-button>
        <a-button
            type="primary"
            @click="uiHandler.updateManuAccount"
        >
            계정 수정
        </a-button>
        </div>
    </a-modal>
</template>
  
<script>
import { VueDraggableNext } from 'vue-draggable-next'
import FormLabel from "@/views/components/FormLabel.vue";
import enums from '@/utils/enums';
import {
    oneBtnDialog,
    convertYnToBool,
    boolToYn,
    deepCopy,
    phoneNumberFormatter,
    confirmDialog,
} from '@/utils/utils';
import { modalType } from '../enums/enums';

const { YnEnum } = enums();

export default {
    name: 'UpdateModal',
    components: {
        draggable: VueDraggableNext,
        FormLabel,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
            default: false,
        },
        id: {
            type: String,
            required: false,
            default: false,
        },
    },
    computed: {
        computedShowModal() {
        return this.showModal;
        },
        computedIsIdValid() {
            if(this.didCheck && this.isIdValid) return true;
        },
    },
    emits: ['closeModal','getAccountsList'],
    data() {
        const validationHandler = this.validation();
        
        return {
            uiHandler: this.ui(),
            apiHandler: this.api(),
            validationHandler,
            YnEnum,
            labelCol: {span: 5},
            wrapperCol: {offset: 2, span: 17},
            didCheck: false,
            isIdValid: false,
            role: 'MANUFACTURER',
            formState: {
                deptName: "",
                duty: "",
                name: "",
                username: "",
                mobile: "",
            },
            rules: {
                deptName: [
                    {
                        required: false,
                        message: '부서명을 입력해주세요.',
                        trigger: 'click',
                    }
                ],
                duty: [
                    {
                        required: false,
                        message: '직급을 입력해주세요.',
                        trigger: 'click',
                    }
                ],
                name: [
                    {
                        required: true,
                        message: '이름을 입력해주세요.',
                        trigger: 'click',
                    }
                ],
                mobile: [
                    {
                        required: true,
                        trigger: 'click',
                        validator: validationHandler.validatePhoneNumber,
                    }
                ],
            },
        };
    },

    async mounted() {
    },
    watch: {
        showModal(newValue, oldValue) {
            if(newValue) {
            }
        },
        id(newId, oldId) {
            if(newId) this.uiHandler.getAccountInfo(newId);
        },
        'formState.mobile': {
            handler: function (newVal, oldVal) {
                if(!newVal) return;
                const cleanVal = newVal.replace(/\D/g, '');

                // Maximum length check
                if (cleanVal.length > 11) {
                this.formState.mobile = oldVal;
                return;
                }

                this.formState.mobile = phoneNumberFormatter(cleanVal);
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        ui() {
        return {
      
            closeModal: () => {
                this.$emit('closeModal', modalType.create, false);
                this.$emit('getAccountsList');
            },
            resetDidCheck: (input) => {
                this.didCheck = false;
                this.isIdValid = false;
            },
            getAccountInfo: async (id) => {
                try {
                    const response = await this.apiHandler.getAccountInfo(id);
                    if(!response || !response.data) return;
                    const { username, name, mobile, deptName, duty} = response.data;
                    if(deptName) {
                        this.formState.deptName = deptName;
                    } else {
                        this.formState.deptName = '';
                    }
                    if(duty) {
                        this.formState.duty = duty;
                    } else {
                        this.formState.duty = '';
                    }
                    this.formState.username = username;
                    this.formState.name = name;
                    this.formState.mobile = mobile;
                } catch(error) {
                    console.log(error);
                }
            },
            resetPassword: async () => {
                try {
                    const confirmResult = await confirmDialog(this.$i18n.t('hospital_pwmodal_title'), this.$i18n.t('hospital_pwmodal_msg'));
                    if(confirmResult) {
                        const response = await this.apiHandler.resetPassword(this.id);
                        if (response.status === 200 || response.status === 201) {
                            await oneBtnDialog(this.$i18n.t('hospital_pwinit_done_title'),this.$i18n.t('hospital_pwinit_done_content'), false);
                        }
                    }
                } catch (error) {
                    console.log(error);
                    await oneBtnDialog(this.$i18n.t('hospital_pwinit_fail_title'),this.$i18n.t('hospital_pwinit_fail_content'), false);
                }
            },
            updateManuAccount: async () => {
                this.$refs.formRef.validate().then(async () => {
                    try {
                        const obj = {
                            name: this.formState.name,
                            mobile: this.formState.mobile,
                            deptName: this.formState.deptName,
                            duty: this.formState.duty,
                        };

                        const result = await this.apiHandler.updateManuAccount(this.id, obj);
                        if(result.status !== 200 && result.status !== 201) throw new Error();
                        await oneBtnDialog('계정 정보 수정 성공', '계정 정보를 수정하였습니다.', false);
                        this.uiHandler.closeModal();
                    } catch(error) {
                        console.log(error);
                        await oneBtnDialog('계정 정보 수정 실패', '계정 정보 수정에 실패하였습니다.', false);
                    }

                    
                }).catch(async error => {
                    console.error('error', error);
                })
            },
        }
        },
        validation() {
            return {
                validateId: (_rule, value) => {
                    let text = '';
                    if (!value) {
                        text = this.$i18n.t('hospitalw_message_manager_id_err_content');
                        return Promise.reject(new Error(text));
                    } 
                    if(!/^[a-zA-Z0-9_]*$/.test(value)) {
                        text = this.$i18n.t('manu_acc_id_rule_err');
                        return Promise.reject(new Error(text));
                    } 
                    if(value && !this.didCheck) {
                        text = this.$i18n.t('hospitalw_message_manager_id_valid_err_content');
                        return Promise.reject(new Error(text));
                    }
                    if(this.didCheck && !this.isIdValid) {
                        text = this.$i18n.t('hospitalw_message_manager_id_exist');
                        return Promise.reject(new Error(text));
                    }
                    return Promise.resolve();
                },
                validatePhoneNumber: (_rule, value) => {
                    let text = '';
                    if (!value) {
                        text = '휴대폰 번호를 입력해 주세요.';
                        return Promise.reject(new Error(text))
                    } 
                    if(!value.startsWith('01') || value.length < 12) {
                        text = '휴대폰 번호를 올바르게 입력해 주세요.';
                        return Promise.reject(new Error(text))
                    } 
                    if(value.startsWith('010-0')) {
                        text = '휴대폰 번호를 올바르게 입력해 주세요.';
                        return Promise.reject(new Error(text))
                    }
                    if(value.startsWith('010') && value.length < 13) {
                        text = '휴대폰 번호를 올바르게 입력해 주세요.';
                        return Promise.reject(new Error(text))
                    }
                    return Promise.resolve();
                },
            }
        },
        api() {
            return {
                getDepts: async () => {
                    
                },
                getAccountInfo: async (id) => {
                    try {
                        if(!id) throw new Error('body 객체 없음');
                        const response = await this.$apiInstance.get(`/accounts/other/${id}`);
                        if (response.status !== 200 && response.status !== 201) throw new Error('state error');
                        return response;
                    } catch (error) {
                        console.log(error);
                        return error;
                    }
                },
                resetPassword: async (id) => {
                    try {
                        if(!id) throw new Error('body 객체 없음');
                        const response = await this.$apiInstance.put(`/companies/resetPassword/${id}`);
                        if (response.status !== 200 && response.status !== 201) throw new Error('state error');
                        return response;
                    } catch (error) {
                        console.log(error);
                        return error;
                    }
                },
                updateManuAccount: async (id, obj) => {
                    try {
                        if(!obj) throw new Error('body 객체 없음');
                        const response = await this.$apiInstance.put(`/accounts/other/${id}`, obj);
                        if (response.status !== 200 && response.status !== 201) throw new Error('state error');
                        return response;
                    } catch (error) {
                        console.log(error);
                        return error;
                    }
                },
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/manu-account.scss';



@media screen and (max-width:767px) {
    .row{
        padding: 14px 14px 36px 14px !important
    }
    .item-btn-area{
        max-width: none;
    }
    p{
        margin-bottom: 0;
    }
}
@media screen and (min-width:768px) and (max-width:1023px){
    .w-35 {
        width: 50% !important;
    }
    p{
        margin-bottom: 0;
    }
}
</style>